import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=3f02e8b3&scoped=true&"
import script from "./orderView.vue?vue&type=script&lang=js&"
export * from "./orderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02e8b3",
  null
  
)

export default component.exports